import { useContext } from 'react';
import { HiOutlinePlus } from 'react-icons/hi';
import { Button } from '@Components/Button/Button';
import { Size } from '@Components/designConstants';
import { FormContext, formObjDefault } from '../wto-form-context';
import { WtoTab, WtoTabType } from '../web-traffic-optimization-constants';
import './Menubar.scss';

interface MenubarProps {
  tab: WtoTabType;
  goToTab: (tab: WtoTabType) => void;
  loading: boolean;
}

export const Menubar = ({ tab, goToTab, loading }: MenubarProps) => {
  const { setWtoFormObj } = useContext(FormContext);

  if (tab !== WtoTab.ROUTE_TABLE || loading) return undefined;

  return (
    <div className='web-traffic-optimization-actions'>
      <Button
        size={Size.LG}
        leadingElement={<HiOutlinePlus />}
        onClick={() => {
          setWtoFormObj(formObjDefault);
          goToTab(WtoTab.ROUTE_DETAILS);
        }}
      >
        Create Route
      </Button>
    </div>
  );
};
